export default __webpack_public_path__ + "static/images-world-map-right-bf09d61ac1f3c37135cf6a76c3e0a47b.svg";